import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Update({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Update</title>
      <path
        d="M19.0789 17.1431C19.3224 16.808 19.2481 16.339 18.913 16.0955C18.5779 15.8521 18.1088 15.9264 17.8654 16.2615L19.0789 17.1431ZM19.9842 12.5023L19.4539 13.0327C19.7468 13.3256 20.2217 13.3256 20.5145 13.0327L19.9842 12.5023ZM22.0145 11.5327C22.3074 11.2398 22.3074 10.7649 22.0145 10.472C21.7217 10.1791 21.2468 10.1791 20.9539 10.472L22.0145 11.5327ZM19.0145 10.472C18.7217 10.1791 18.2468 10.1791 17.9539 10.472C17.661 10.7649 17.661 11.2398 17.9539 11.5327L19.0145 10.472ZM17.8654 16.2615C16.8392 17.6739 15.3378 18.6686 13.6371 19.0628L13.9758 20.524C16.0284 20.0483 17.8404 18.8478 19.0789 17.1431L17.8654 16.2615ZM13.6371 19.0628C11.9363 19.457 10.1504 19.2242 8.60751 18.4073L7.90561 19.733C9.76775 20.7189 11.9231 20.9998 13.9758 20.524L13.6371 19.0628ZM8.60751 18.4073C7.0646 17.5904 5.86829 16.2441 5.23837 14.6159L3.83941 15.1571C4.59965 17.1222 6.04348 18.747 7.90561 19.733L8.60751 18.4073ZM5.23837 14.6159C4.60845 12.9877 4.58723 11.1868 5.17861 9.54417L3.76729 9.03606C3.05356 11.0185 3.07916 13.192 3.83941 15.1571L5.23837 14.6159ZM5.17861 9.54417C5.77 7.90154 6.93426 6.52748 8.45749 5.67442L7.72456 4.36568C5.88617 5.39523 4.48103 7.05358 3.76729 9.03606L5.17861 9.54417ZM8.45749 5.67442C9.98073 4.82137 11.7606 4.54662 13.4702 4.90065L13.7744 3.43182C11.7111 3.00453 9.56295 3.33613 7.72456 4.36568L8.45749 5.67442ZM13.4702 4.90065C15.1798 5.25468 16.7042 6.21372 17.7633 7.60157L18.9558 6.69154C17.6775 5.01656 15.8377 3.8591 13.7744 3.43182L13.4702 4.90065ZM17.7633 7.60157C18.8225 8.98941 19.3453 10.7129 19.2357 12.4552L20.7327 12.5494C20.865 10.4465 20.2341 8.36653 18.9558 6.69154L17.7633 7.60157ZM20.5145 13.0327L22.0145 11.5327L20.9539 10.472L19.4539 11.972L20.5145 13.0327ZM20.5145 11.972L19.0145 10.472L17.9539 11.5327L19.4539 13.0327L20.5145 11.972Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M12 8V12L15 15"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
